import { CircularProgress } from '@mui/material';
import React from 'react';

const LoadingView = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: '10000',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: 'gray',
          opacity: '0.5',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }}
      >
        <CircularProgress size={70} />
      </div>
    </div>
  );
};

export default LoadingView;
